<template>
  <div>
    <v-app-bar fixed elevation="0" color="rgba(0,0,0,0)">
      <v-system-bar flat fixed color="white"></v-system-bar>
      <v-card flat tile color="white" class="ml-10">
        <v-toolbar-title class="mt-12">
          <router-link id="routeToHomepage" :to="{ name: 'homepage' }">
            <v-img
              :src="require('@/assets/fplogo-iab.png')"
              class="ma-4 mr-12"
              alt="FP LOGO"
            />
          </router-link>
        </v-toolbar-title>
      </v-card>
      <v-spacer></v-spacer>
      <v-toolbar-items class="mt-12 pt-6 pr-2">
        <router-link id="routeToLogin" :to="{ name: 'login' }">
          <v-btn
            id="routeToLogin"
            color="primary"
            to="/login"
            dark
            depressed
            tile
            class="mx-2"
            @click.stop="dialog = true"
            >{{ getContent('btn_login') }}</v-btn
          >
        </router-link>
      </v-toolbar-items>
    </v-app-bar>
    <v-content>
      <v-container fluid>
        <v-dialog v-model="dialog" max-width="500" @click:outside="closeDialog">
          <v-card class="pa-6">
            <v-icon
              class="float-right"
              color="primary"
              medium
              @click="closeDialog"
              >mdi-close</v-icon
            >
            <router-view></router-view>
          </v-card>
        </v-dialog>
      </v-container>
    </v-content>
  </div>
</template>
<script>
import homepage from '@/data/json/views/homepage.json'
import { cmsService } from '@/services'
export default {
  components: {},
  data() {
    return {
      dialog: false,
      content: homepage.data,
      slides: [
        {
          src: require('@/assets/img/slides/iStock-475967893.jpg'),
          id: 'SlideOne'
        },
        {
          src: require('@/assets/img/slides/iStock-626967668.jpg'),
          id: 'SlideTwo'
        },
        {
          src: require('@/assets/img/slides/iStock-1040303976.jpg'),
          id: 'SlideThree'
        }
      ]
    }
  },
  created: function() {
    // show dialog if the route is called directly
    if (
      this.$route.name === 'login' ||
      this.$route.name === 'register' ||
      this.$route.name === 'forgotPassword'
    ) {
      this.dialog = true
    }
  },
  methods: {
    closeDialog() {
      this.dialog = false
      this.$router.push('/')
    },
    getContent: function(name) {
      return cmsService.filterCMSContent(this.content, name)
    }
  }
}
</script>
<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:ital,wght@1,200&display=swap');
@media screen and (min-width: 768px) {
  .slider {
    background: linear-gradient(135deg, #56a3b8 0, #2d4453 100%);
    margin-top: 30px;
  }
}
.mdi:before {
  font-weight: bold;
}

.dark-background {
  background-image: linear-gradient(135deg, #56a3b8 0%, #2d4453 100%);
}

.v-card {
  position: relative;
}
.v-btn .z-index {
  position: absolute;
  overflow: visible;
  z-index: 1;
}

.slider .triangle-bottom {
  background-image: require(
    '@/assets/img/slides/verlauf_nach_Slider_unten.png'
  );
  background-repeat: no-repeat;
  background-size: calc(100% + 1px) 41px;
  height: 40px;
  position: relative;
  width: 100%;
  z-index: 3;
  margin-bottom: -1px;
}
.slogan-box {
  width: 400px;
  height: 200px;
  border-color: transparent !important;
  background-image: linear-gradient(135deg, #56a3b8 0, #2d4453 100%);
  overflow-x: hidden;
}
.slogan-text {
  font-family: 'Source Sans Pro', sans-serif;
}
</style>
